export const NOTIFICATIONS_FETCH_CURRENT_USER = 'NOTIFICATIONS_FETCH_CURRENT_USER';
export const NOTIFICATIONS_UPDATE_DATASET = 'NOTIFICATIONS_UPDATE_DATASET';
